export default __webpack_public_path__ + "static/media/dumbTurtle.b7498fa2.jpg";